module.exports = __webpack_public_path__ + "static/media/HomePic7.8766fc52.jpeg";